<app-page-header></app-page-header>

<app-navbar [navLeftTemplate]="navLeft" [navRightTemplate]="navRight">

  <ng-template #navLeft>
    <button mat-button [matMenuTriggerFor]="dispositivi_menu" *ngIf="IsVisible({ itemName: 'Dispositivi' })"> {{ getMenuTitle('Dispositivi') }} </button>

    <mat-menu #dispositivi_menu="matMenu">
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: { itemName: 'Lista Dispositivi' } }"/>
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: { itemName: 'Gestione Dispositivi' } }"/>
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: { itemName: 'Storico' } }"/>
    </mat-menu>

  </ng-template>

  <ng-template #navRight>
    <button mat-button [matMenuTriggerFor]="utente_menu" *ngIf="IsVisible({ itemName: 'Utente' })"> {{ getMenuTitle('Utente') }} </button>
    <button mat-button [matMenuTriggerFor]="impostazioni_menu" *ngIf="IsVisible({ itemName: 'Impostazioni' })"> {{ getMenuTitle('Impostazioni') }} </button>

    <mat-menu #utente_menu="matMenu">
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: { itemName: 'Scollegamento Utente', onClick: logout.bind(this) }}"/>
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: { itemName: 'Cambio Password' } }"/>
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: { itemName: 'Elimina Account' } }"/>
    </mat-menu>
    <mat-menu #impostazioni_menu="matMenu">
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: { itemName: 'Gestione Utenti' } }"/>

      <ng-container *ngTemplateOutlet="menuItemTemplate; context: {
        $implicit: {
          itemName: 'English',
          onClick: switchLang.bind(this),
          onClickArg: 'en',
          iconSource: '../../../assets/img/en.png'
        } }"/>

      <ng-container *ngTemplateOutlet="menuItemTemplate; context: {
        $implicit: {
          itemName: 'Italiano',
          onClick: switchLang.bind(this),
          onClickArg: 'it',
          iconSource: '../../../assets/img/it.png'
        } }"/>

    </mat-menu>

  </ng-template>

  <ng-template #menuItemTemplate let-item>
    <button mat-menu-item
      *ngIf="IsVisible(item)"
      (click)="item.onClick ? item.onClick(item.onClickArg) : setActiveMenuName(item.itemName)">
      <img *ngIf="item.iconSource" src="{{item.iconSource}}" class="menu-item-img">
        {{getMenuTitleByItem(item)}}
    </button>
  </ng-template>

</app-navbar>

<div class="activeMenu" *ngIf="getActiveMenuPageTitle() != ''">
  <div class="mat-form-field-wrapper">
    <div class="mat-form-field-label">
      <h3>{{ getActiveMenuPageTitle() }}</h3>
    </div>
  </div>
</div>
